export const env = process.env.REACT_APP_ENV || ''
export const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN

export const awsRegion = process.env.REACT_APP_AWS_REGION
export const awsEndpoint = process.env.REACT_APP_AWS_ENDPOINT
export const awsAccount = process.env.REACT_APP_AWS_ACCOUNT
export const awsSystemKey = process.env.REACT_APP_AWS_SYSTEM_KEY || ''
export const awsSystemSecret = process.env.REACT_APP_AWS_SYSTEM_SECRET || ''
export const awsS3Bucket = process.env.REACT_APP_AWS_S3_BUCKET || ''
export const awsS3PublicBucket = process.env.REACT_APP_AWS_S3_PUBLIC_BUCKET || ''

export const serverDomain = process.env.REACT_APP_SERVER_DOMAIN

export const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_KEY || ''
export const googleMapsMapId = process.env.REACT_APP_GOOGLE_MAPS_MAP_ID || ''
